import { AgentSkillKind } from "@common/types/agentSkill";
import {
    AGENT_SKILL_MANAGE_FORBIDDEN_TOOLTIP,
    RESET_TO_DEFAULT_LABEL,
} from "./agentSkillCopy";

export type AgentSkillMenuItemKey =
    | "open"
    | "editDetails"
    | "disable"
    | "enable"
    | "delete"
    | "reset";

export interface AgentSkillMenuItem {
    key: AgentSkillMenuItemKey;
    label: string;
    isDisabled: boolean;
    reason?: string;
}

interface ActionableAgentSkill {
    isEnabled: boolean;
    kind: AgentSkillKind;
    isCustomized: boolean;
}

// Kick skills are never disabled or deleted; a firm's edit of one is reset
// to Kick's default instead.
export const getAgentSkillActions = ({
    skill,
    canManage,
}: {
    skill: ActionableAgentSkill;
    canManage: boolean;
}): AgentSkillMenuItem[] => {
    const manage = canManage
        ? { isDisabled: false }
        : { isDisabled: true, reason: AGENT_SKILL_MANAGE_FORBIDDEN_TOOLTIP };
    const open: AgentSkillMenuItem = {
        key: "open",
        label: "Open",
        isDisabled: false,
    };
    const editDetails: AgentSkillMenuItem = {
        key: "editDetails",
        label: "Edit details",
        ...manage,
    };
    if (skill.kind === AgentSkillKind.KICK) {
        return [
            open,
            editDetails,
            ...(skill.isCustomized
                ? [
                      {
                          key: "reset" as const,
                          label: RESET_TO_DEFAULT_LABEL,
                          ...manage,
                      },
                  ]
                : []),
        ];
    }
    return [
        open,
        editDetails,
        skill.isEnabled
            ? { key: "disable", label: "Disable", ...manage }
            : { key: "enable", label: "Enable", ...manage },
        { key: "delete", label: "Delete", ...manage },
    ];
};
